import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

// ===== MAU18: Champions Night — deep navy + gold stars, 1-column =====
const Mau18 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const c = {
        bg: '#03082a',
        bg2: '#060d3a',
        gold: '#c9a227',
        goldLight: '#f5d76e',
        goldDark: '#8B6914',
        text: '#ffffff',
        textMuted: 'rgba(255,255,255,0.5)',
        cardBg: '#080e30',
        cardBorder: 'rgba(201,162,39,0.4)',
        rowAlt: '#0a1238'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    // Mini star positions (deterministic)
    const stars = [...Array(30)].map((_, i) => ({
        x: ((i * 37 + 13) % 97),
        y: ((i * 59 + 7) % 95),
        r: 0.15 + (i % 3) * 0.1
    }))

    return (
        <div id={id} style={{ width, minHeight: width / 1.3, fontFamily: 'SFUHelveticaCondensedBold', background: `radial-gradient(ellipse at 50% 0%, ${c.bg2} 0%, ${c.bg} 70%)`, position: 'relative', overflow: 'hidden' }}>
            {/* Star dots */}
            {stars.map((s, i) => (
                <div key={i} style={{ position: 'absolute', left: `${s.x}%`, top: `${s.y}%`, width: `${s.r * px}px`, height: `${s.r * px}px`, borderRadius: '50%', background: '#fff', opacity: 0.5, zIndex: 0 }} />
            ))}
            {/* Gold glow top center */}
            <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: `${px * 60}px`, height: `${px * 20}px`, background: `radial-gradient(ellipse, rgba(201,162,39,0.18) 0%, transparent 70%)`, zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1, padding: `${px * 2.5}px` }}>
                {/* HEADER */}
                <div style={{ textAlign: 'center', marginBottom: `${px * 2}px` }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: `${px * 1.5}px` }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', filter: `drop-shadow(0 0 8px rgba(201,162,39,0.6))` }} />
                        <div style={{ flex: 1, textAlign: 'center' }}>
                            {/* Gold star row */}
                            <div style={{ display: 'flex', justifyContent: 'center', gap: `${px * 0.5}px`, marginBottom: `${px * 0.5}px` }}>
                                {['★', '★', '★', '★', '★'].map((s, i) => (
                                    <span key={i} style={{ color: c.gold, fontSize: `${px * 1.8}px`, textShadow: `0 0 6px rgba(201,162,39,0.6)` }}>{s}</span>
                                ))}
                            </div>
                            <h1 style={{ color: c.goldLight, fontSize: `${px * 5}px`, textTransform: 'uppercase', margin: 0, letterSpacing: `${px * 0.5}px`, textShadow: `0 2px 15px rgba(201,162,39,0.5), 0 0 40px rgba(201,162,39,0.2)` }}>
                                {t(titleTemplate(dataSchedules[0]?.dataGo))}
                            </h1>
                            <h2 style={{ color: c.text, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: `${px * 0.4}px 0 0`, opacity: 0.85 }}>{dataSeason?.name}</h2>
                            {t(numberRound) === numberRound && (
                                <div style={{ display: 'inline-block', background: `linear-gradient(90deg,${c.goldDark},${c.gold},${c.goldDark})`, color: '#000', padding: `${px * 0.35}px ${px * 2.5}px`, borderRadius: `${px * 0.4}px`, fontSize: `${px * 1.9}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px` }}>{t('round')} {numberRound}</div>
                            )}
                            {t(numberRound) && t(numberRound) !== numberRound && (
                                <div style={{ display: 'inline-block', background: `linear-gradient(90deg,${c.goldDark},${c.gold},${c.goldDark})`, color: '#000', padding: `${px * 0.35}px ${px * 2.5}px`, borderRadius: `${px * 0.4}px`, fontSize: `${px * 1.9}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px` }}>{t(numberRound)}</div>
                            )}
                        </div>
                        <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                    </div>
                    {/* Gold divider */}
                    <div style={{ height: `${px * 0.2}px`, background: `linear-gradient(90deg, transparent, ${c.gold}, transparent)` }} />
                </div>

                {/* MATCHES — 1 column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: `${px * 1}px` }}>
                    {dataSchedules[0]?.dataGo?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')?.map((i, idx) => (
                        <Item18 key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} c={c} />
                    ))}
                </div>

                {/* Gold separator */}
                <div style={{ height: `${px * 0.2}px`, background: `linear-gradient(90deg, transparent, ${c.gold}, transparent)`, marginTop: `${px * 2}px` }} />

                {/* SPONSORS */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ marginTop: `${px * 1.5}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: `${px * 2}px` }}>
                        {sponsorData?.slice(0, 10)?.map((s, idx) => <Image key={idx} src={s.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />)}
                    </div>
                )}
                <p style={{ textAlign: 'right', color: `rgba(201,162,39,0.45)`, fontSize: `${px * 1.6}px`, marginTop: `${px * 1}px`, letterSpacing: '2px' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}</p>
            </div>
        </div>
    )
}

const Item18 = React.memo(({ data, px, classCustom, idx, c }) => {
    const { t } = useTranslation()
    const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
    const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']
    let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
    let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''
    let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
    let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name
    let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
    let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

    return (
        <div style={{ display: 'flex', alignItems: 'center', background: idx % 2 === 0 ? c.cardBg : c.rowAlt, border: `1px solid ${c.cardBorder}`, borderLeft: `${px * 0.6}px solid ${c.gold}`, borderRadius: `${px * 0.6}px`, padding: `${px * 1.2}px ${px * 1.8}px`, gap: `${px * 1.2}px`, minHeight: `${px * 10}px` }}>
            {/* Time */}
            <div style={{ minWidth: `${px * 9}px`, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{ color: c.gold, fontSize: `${px * 3}px`, fontWeight: 'bold', lineHeight: 1, textShadow: `0 0 8px rgba(201,162,39,0.4)` }}>{formatDateTime(data?.dateTime, 'time')}</span>
                <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, marginTop: `${px * 0.3}px`, textAlign: 'center' }}>{formatDateTime(data?.dateTime, 'date')}</span>
            </div>
            <div style={{ width: '1px', alignSelf: 'stretch', background: `rgba(201,162,39,0.25)`, flexShrink: 0 }} />
            {/* Home */}
            <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: `${px}px`, overflow: 'hidden' }}>
                <Name18 propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} color={c.text} align="right" />
                <Image src={data?.homeTeam?.logo} style={{ width: `${px * 6}px`, height: `${px * 6}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid ${c.gold}`, flexShrink: 0, backgroundColor: '#fff', boxShadow: `0 0 8px rgba(201,162,39,0.35)` }} />
            </div>
            {/* Score/VS */}
            <div style={{ minWidth: `${px * 22}px`, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.3}px` }}>
                {data?.isCompleted ? (
                    <>
                        <div style={{ background: 'rgba(0,0,0,0.5)', border: `2px solid ${c.gold}`, color: c.goldLight, fontWeight: 900, fontSize: `${px * 3.4}px`, padding: `${px * 0.3}px ${px * 1.5}px`, borderRadius: `${px * 0.4}px`, letterSpacing: '2px', whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 18}px`, textShadow: `0 0 8px rgba(245,215,110,0.5)` }}>
                            {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                            {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                            {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                            {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                        </div>
                        {data?.hasPenalty && <span style={{ color: '#fc0366', fontSize: `${px * 1.3}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore}</span>}
                    </>
                ) : (
                    <div style={{ border: `2px solid ${c.gold}`, color: c.gold, fontWeight: 900, fontSize: `${px * 2.6}px`, padding: `${px * 0.3}px ${px * 1.8}px`, borderRadius: `${px * 0.4}px`, letterSpacing: '3px', whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 14}px` }}>VS</div>
                )}
            </div>
            {/* Away */}
            <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: `${px}px`, overflow: 'hidden' }}>
                <Image src={data?.awayTeam?.logo} style={{ width: `${px * 6}px`, height: `${px * 6}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid rgba(255,255,255,0.35)`, flexShrink: 0, backgroundColor: '#fff' }} />
                <Name18 propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} color={c.text} align="left" />
            </div>
            {/* Stadium */}
            {data?.stadium && (
                <div style={{ minWidth: `${px * 8}px`, maxWidth: `${px * 12}px`, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center', lineHeight: 1.3 }}>{data.stadium}</span>
                </div>
            )}
        </div>
    )
}, (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data))

const Name18 = React.memo(({ name, px, propClass, color, align }) => {
    const reSizeBasedOnWidth = () => {
        const el = document.querySelector(`.${propClass}`)
        const container = document.querySelector(`.contain${propClass}`)
        if (!el || !container) return
        const fontSize = window?.getComputedStyle(el)?.fontSize
        el.style.fontSize = parseFloat(fontSize) - 0.25 * px + 'px'
        if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
    }
    const processInput = () => {
        const el = document.querySelector(`.${propClass}`)
        if (!el) return
        el.innerHTML = name
        el.style.fontSize = px * 2.6 + 'px'
        reSizeBasedOnWidth()
    }
    React.useEffect(() => { processInput() }, [name])
    return (
        <div className={`contain${propClass}`} style={{ flex: 1, height: `${px * 7}px`, display: 'flex', alignItems: 'center', justifyContent: align === 'right' ? 'flex-end' : 'flex-start', overflow: 'hidden' }}>
            <h2 className={propClass} style={{ color, textAlign: align, textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2, fontSize: `${px * 2.6}px` }} />
        </div>
    )
}, (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name))

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => { if (props.src) getBase64(props.src).then(r => setData(r)) }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau18, areEqual)
